import {useEffect, useRef} from 'react';
import Swal from 'sweetalert2';
import {INTERVALO_CHECK_VERSAO} from '../../config/constant';

const VERSION_URL = `${process.env.PUBLIC_URL}/config/version.json`;

const fetchVersion = async () => {
  const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, {cache: 'no-store'});
  if (!res.ok) return null;
  return res.json();
};

// Verifica periodicamente se uma nova versão do sistema foi publicada
// (comparando build/config/version.json, gerado a cada build) e avisa
// o usuário, evitando que ele fique preso numa versão antiga em cache.
export default function VersionCheck() {
  const versaoAtual = useRef(null);
  const avisoExibido = useRef(false);

  useEffect(() => {
    let ativo = true;

    const checar = async () => {
      try {
        const dados = await fetchVersion();
        if (!ativo || !dados) return;

        if (versaoAtual.current === null) {
          versaoAtual.current = dados.buildTime || dados.version;
          return;
        }

        const versaoRecebida = dados.buildTime || dados.version;
        if (versaoRecebida && versaoRecebida !== versaoAtual.current && !avisoExibido.current) {
          avisoExibido.current = true;
          Swal.fire({
            icon: 'info',
            title: 'Nova versão disponível!',
            html: `Uma nova versão do sistema (v${dados.version}) já está disponível.<br/>Atualize a página para continuar com a versão mais recente.`,
            confirmButtonText: 'Atualizar agora',
            showCancelButton: true,
            cancelButtonText: 'Depois',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            } else {
              avisoExibido.current = false;
            }
          });
        }
      } catch (e) {
        // Falha ao checar versão (offline, etc.) não deve impactar o uso do sistema
      }
    };

    checar();
    const id = setInterval(checar, INTERVALO_CHECK_VERSAO);

    return () => {
      ativo = false;
      clearInterval(id);
    };
  }, []);

  return null;
}
